import RestApi from './../../api/automation-api-client'

const srvcEndpoint = '/leaderboards/live-feed'

export default {
  search: async (req, opts) => RestApi.request('GET', srvcEndpoint, req, opts),
  getLatest: async (limit = 20) => RestApi.request('GET', srvcEndpoint, { query: { limit } }),
  // Cursor-paginated history fetch. Returns eligible rows older than the given
  // av_id, newest-first. Bypasses the live-feed Redis cache server-side.
  getOlderThan: async (beforeAvId, limit = 20) =>
    RestApi.request('GET', srvcEndpoint, {
      query: { before_av_id: beforeAvId, limit },
    }),
}
